import { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from '@components/common/Button';
import { FormSelect } from '@components/common/FormSelect/FormSelect';
import { FormTextField } from '@components/common/FormTextField/FormTextField';
import { Table } from '@components/common/Table/Table';
import { TableBody } from '@components/common/Table/TableBody/TableBody';
import { TableCell } from '@components/common/Table/TableCell/TableCell';
import { TableContainer } from '@components/common/Table/TableContainer/TableContainer';
import { TableHead } from '@components/common/Table/TableHead/TableHead';
import { TableRow } from '@components/common/Table/TableRow/TableRow';
import { DeleteIcon } from '@components/common/Icons/DeleteIcon';
import { ISelectOption } from '@components/common/Select/types';
import { IIntermediaryFeesTable, tableColumnsNames } from './types';
import { intermediaryFeesQuestions } from '../questions';
import { FormCurrencyField } from '@components/common/FormCurrencyField/FormCurrencyField';
export const IntermediaryFeesTable: FC<IIntermediaryFeesTable> = ({ fees, onAddFee, onRemoveFee, paperProps }) => {
  const intl = useIntl();

  return (
    <div className={'my-2 w-full overflow-hidden rounded-sm bg-white shadow-sm'} {...paperProps}>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {Object.keys(intermediaryFeesQuestions.fees).map(feeKey => (
                <TableCell key={feeKey} className={'whitespace-nowrap'}>
                  <FormattedMessage id={intermediaryFeesQuestions.fees[feeKey].labelKey} />
                </TableCell>
              ))}
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody columnsNumber={tableColumnsNames.length}>
            {fees.map((fee, index) => {
              const { whenPayable, howPayable } = intermediaryFeesQuestions.fees;

              return (
                <TableRow key={fee.id}>
                  <TableCell className={'border-none p-2 pr-0'}>
                    <FormTextField
                      textFieldProps={{
                        size: 'small',
                        type: 'text',
                      }}
                      rules={{ required: true }}
                      name={`fees[${index}].description`}
                    />
                  </TableCell>
                  <TableCell className={'border-none p-2 pr-0'}>
                    <FormCurrencyField name={`fees[${index}].amount`} rules={{ required: true }} />
                  </TableCell>
                  <TableCell className={'w-40 border-none p-2 pr-0'}>
                    <FormSelect
                      name={`fees[${index}].whenPayable`}
                      options={whenPayable.options}
                      selectProps={{
                        isOptionEqualToValue: (option: ISelectOption, selectedOptionValue: string) =>
                          option.value === selectedOptionValue,
                        value: fee.whenPayable,
                      }}
                      rules={{ required: true }}
                      selectInputProps={{
                        placeholder: intl.formatMessage({ id: 'placeholders.select' }),
                        size: 'small',
                      }}
                    />
                  </TableCell>
                  <TableCell className={'w-40 border-none p-2 pr-0'}>
                    <FormSelect
                      name={`fees[${index}].howPayable`}
                      options={howPayable.options}
                      className={'w-full'}
                      selectProps={{
                        isOptionEqualToValue: (option: ISelectOption, selectedOptionValue: string) =>
                          option.value === selectedOptionValue,
                        value: fee.howPayable,
                      }}
                      rules={{ required: true }}
                      selectInputProps={{
                        placeholder: intl.formatMessage({ id: 'placeholders.select' }),
                        size: 'small',
                      }}
                    />
                  </TableCell>
                  <TableCell className={'border-none p-2 pr-0'}>
                    <FormCurrencyField name={`fees[${index}].refundableAmount`} rules={{ required: true }} />
                  </TableCell>
                  <TableCell className={'cursor-pointer border-none p-2 text-center'}>
                    <DeleteIcon data-testid={'deleteIcon'} htmlColor={'grey'} onClick={() => onRemoveFee(index)} />
                  </TableCell>
                </TableRow>
              );
            })}
            <TableRow>
              <TableCell className={'text-center'} colSpan={9}>
                <Button onClick={onAddFee}>Add fee</Button>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
